module.exports = __webpack_public_path__ + "1c5b2155341e8f6bdd526e5f8fda336a.png";